export default __webpack_public_path__ + "static/media/tablet-background.c3ff16c6.svg";